import { LoadingSpinner } from "components/LoadingSpinner";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useGetCaseRateRulesetByIdQuery } from "store/queries/pricing";

import { CptCodes } from "./components/CptCodes";
import { ExcludedCptCodes } from "./components/ExcludedCptCodes";
import { Header } from "./components/Header";
import { PerDiemToggle } from "./components/PerDiemToggle";
import { ProviderAndPayerCopySection } from "./components/ProviderAndPayerCopySection";
import { RuleName } from "./components/RuleName";
import { SubmitCaseRate } from "./components/SubmitCaseRate";

export function CopyCaseRateRulesPage() {
  useDocumentTitle("Copy Case Rate Rules");
  const { id } = useParams();
  const { data: ruleset, isLoading } = useGetCaseRateRulesetByIdQuery(id);

  const methods = useForm({
    defaultValues: {
      provider: [
        {
          name: ruleset?.data.provider.name,
          value: ruleset?.data.provider.id,
        },
      ],
      payerName: [
        {
          name: ruleset?.data?.payer?.name,
          value: ruleset?.data?.payer?.id,
        },
      ],
      groupName: ruleset?.data.groupName,
      cptCodes: ruleset?.data.cptCodes,
      excludedCptCodes: ruleset?.data.excludedCptCodes,
      isPerDiem: ruleset?.data.isPerDiem ?? false,
    },
  });

  useEffect(() => {
    if (ruleset) {
      methods.reset({
        provider: [
          {
            name: ruleset?.data.provider.name,
            value: ruleset?.data.provider.id,
          },
        ],
        payerName: [
          {
            name: ruleset?.data?.payer?.name,
            value: ruleset?.data?.payer?.id,
          },
        ],
        groupName: ruleset?.data.groupName,
        cptCodes: ruleset?.data.cptCodes,
        excludedCptCodes: ruleset?.data.excludedCptCodes,
        isPerDiem: ruleset?.data.isPerDiem ?? false,
      });
    }
  }, [ruleset, methods]);

  if (isLoading) {
    return <LoadingSpinner />;
  }
  return (
    <FormProvider {...methods}>
      <Header name={ruleset?.data.groupName} isCaseRate />
      <ProviderAndPayerCopySection
        initialProviders={[
          {
            name: ruleset?.data.provider.name || "",
            value: ruleset?.data.provider.id || "",
          },
        ]}
        initialPayers={[
          {
            name: ruleset?.data?.payer?.name || "",
            value: ruleset?.data?.payer?.id || "",
          },
        ]}
      />
      <RuleName />
      <CptCodes />
      <ExcludedCptCodes />
      <PerDiemToggle />
      {id && ruleset && <SubmitCaseRate />}
    </FormProvider>
  );
}
